/**
 * @generated SignedSource<<b313ad137368ed67ea21892433f2c250>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InformativeMap_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sidebar",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapSidebar_sidebar"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapContextProvider_map"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapWithSidebarLayout_map"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapSidebar_map"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapFilters_map"
    }
  ],
  "type": "InformativeMap",
  "abstractKey": null
};

node.hash = "d3a58504d9522e8b4447713319202a9a";

module.exports = node;
